<template>
    <div>
        <station-filter-sidebar></station-filter-sidebar>
        <div class="row map-row" style="margin:0;">
            <route-panel></route-panel>
            <station-map></station-map>
        </div>
        <!--<station-detail></station-detail>-->
    </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import {loaded} from 'vue2-google-maps'

export default {
  components: {
  },
  data() {
    return {
      showDetail: false,
      showSidebar: false,
      group: {},
      address: '',
      gLoaded: false
    }
  },
  mounted () {
  },
  created () {
  },
  methods: {
    ...mapActions([
      'getGoogleStatus',
      'selectedStation'
    ])
  },
  computed: {
    ...mapGetters({
      location: 'location',
      stations: 'stations',
      googleStatus: 'googleStatus'
    })
  }
}
</script>

<style lang="scss">
  body {
    &.map-page {
      min-height: 0;
      max-height: 100vh;
      overflow: hidden;
        .anhaenger {
            display: none;
        }
    }
  }
</style>



// WEBPACK FOOTER //
// gasStationFinder.vue?7896507c